import React, {
	memo,
	useEffect,
	useState
} from 'react';
import PropTypes from 'prop-types';

import styles from './table.module.css';

const RecordCount = ( {
	pageLength,
	pageIndex,
	pageSize,
	rows
} ) => {
	const [ range, setRange ] = useState( '' );

	useEffect( () => {
		if ( pageLength === 0 ) {
			setRange( '0' );
		} else {
			const current = pageLength;
			const prev = pageIndex * pageSize;
			const low = prev + 1;
			let high = prev + current;

			low === high
				? setRange( `${ high }` )
				: setRange( `${ low }-${ high }` );
		}
	}, [
		pageLength,
		pageIndex,
		pageSize,
		rows
	] );

	return (
		<div className={ styles.recordCount }>
			{ `Showing record${ range !== `${ rows.length }` ? 's' : '' } ${ range } of ${ rows.length }` }
		</div>
	);
};

RecordCount.propTypes = {
	pageLength: PropTypes.number.isRequired,
	pageIndex: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	rows: PropTypes.array.isRequired
};

export default memo( RecordCount );
